import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import Chart, {ActiveElement, ChartEvent} from "chart.js/auto";
import {PieChartData} from "../../../interfaces/pie-chart-data";

@Component({
  selector: 'brt-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements AfterViewInit {

  @ViewChild("chartEl") chartEl!: ElementRef;
  @Output('onIndexHover') onIndexHover = new EventEmitter<number>();
  @Output('onIndexHoverOut') onIndexHoverOut = new EventEmitter<void>();

  @Input('data') set setData(data: PieChartData) {
    this.data = data;
  }

  data!: PieChartData;
  currentSelection = -1;

  ngAfterViewInit(): void {
    const that = this;
    if(this.data) {
      const chart = new Chart(
        this.chartEl.nativeElement as HTMLCanvasElement,
        {
          type: 'pie',
          options: {
            // onHover: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
            //   if(this.currentSelection !== elements[0].index) {
            //     this.onIndexHover.emit(elements[0].index);
            //     this.currentSelection = elements[0].index;
            //   }
            //   console.log(event.type);
            //   console.log(event);
            // },
            events: ["mouseenter", "mouseout", "mousemove", "mouseleave"],
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                enabled: false
              }
            },
            hover: {
              mode: 'nearest',
              intersect: false,
            }
          },
          plugins: [{
            id: 'mouseoutEvent',

            beforeEvent(chart, args, pluginOptions) {
              const event = args.event;
              // console.log(event);
              if(event.type === "mouseout") {
                that.onIndexHoverOut.emit();
              } else if(event.type === "mousemove") {
                const activeElements = chart.getActiveElements();
                if(activeElements.length > 0){
                  that.onIndexHover.emit(activeElements[0].index);
                }
              }
            }
          }],
          data: {
            labels: this.data.datasets.map(item => item.label),
            datasets: [
              {
                label: '',
                data: this.data.datasets.map(row => row.items[0].value),
                borderWidth: 0,
                backgroundColor: this.data.datasets.map(row => row.color),
              }
            ]
          }
        }
      );
    }
  }

}
